var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-calendar", class: { "is-active": _vm.index == 1 } },
    [
      _c("div", { staticClass: "c-pdf-settings" }, [
        _c("div", { staticClass: "c-pdf-settings__label" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("pdf.download.button.label")))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "c-pdf-settings__button" }, [
          _c(
            "a",
            {
              staticClass:
                "button button--action button--action--pdf button--small",
              attrs: { title: _vm.$t("generatepdf") },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.showPdfDialog()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("generatepdf")))]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("v-week-header", {
        attrs: { days_of_week: this.days_of_week, kolonne: this.kolonne },
      }),
      _vm._v(" "),
      _vm.kolonne.length === 0
        ? _c("div", { staticClass: "callout warning" }, [
            _vm._v(_vm._s(_vm.$t("weeks.kolonne.empty"))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(this.kolonne, function (item, i) {
        return _c("div", { key: i, staticClass: "c-calandar__row" }, [
          _c(
            "div",
            {
              staticClass: "loading-wrapper",
              class: { "is-loading": _vm.isLoading },
            },
            [
              _c("v-week-row", {
                attrs: {
                  id: i,
                  index: _vm.index,
                  kolonne_number: item.id,
                  days_of_week: _vm.days_of_week,
                  week_results: _vm.week_results,
                  weekday_objects: _vm.weekday_objects,
                  holidays: _vm.holidays,
                },
                on: { onEndDragDrop: _vm.onEndDragDrop },
              }),
            ],
            1
          ),
        ])
      }),
      _vm._v(" "),
      _c("v-pdf-dialog", {
        attrs: {
          isVisible: _vm.pdfDialogIsVisible,
          kolonne: _vm.pdfKolonne,
          date: _vm.pdfWeekStartdate,
        },
        model: {
          value: _vm.pdfDialogIsVisible,
          callback: function ($$v) {
            _vm.pdfDialogIsVisible = $$v
          },
          expression: "pdfDialogIsVisible",
        },
      }),
      _vm._v(" "),
      _c("v-form-message", {
        attrs: {
          type: "error",
          id: "form-error",
          message: _vm.rescheduleError,
          autoCloseTimeout: 0,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }